import { Component } from '@angular/core';
import { Question } from '../declarations';
import { Store } from '@ngrx/store';
import { Language } from 'app/shared/model/enums';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  activeState: boolean[] = [true, false, false];
  subscriptions = new Subscription();
  currentQuestions: Question[];
  cardsAboutUsContent: { title: string; content: string }[] = [];

  //    enStrings: Question[] = [
  cardsAboutUsContentEn = [
    {
      title: "Our Mission for Your Growth",
      content: "Spin to Win strives to provide every business owner with the tools to increase revenue by creating an unforgettable customer experience.\n The platform is more than just a system—it’s a partner in business growth, offering support in branding, marketing, and customer retention."
    },
    {
      title: "What Makes Spin to Win your Perfect Choice?",
      content: `
       &nbsp;&nbsp;&nbsp;&nbsp; &bull;&nbsp; Deliver an exciting customer experience.
        &bull;&nbsp; Drive increased revenues and build customer loyalty.
        &bull;&nbsp; Provide full support to businesses throughout the setup and marketing processes.
      `
    },
    {
      title: "Proven Results",
      content: "With Spin to Win, businesses worldwide are witnessing dramatic improvements in customer retention and revenue growth. Ovadia and the team continue to innovate, optimize, and support any business eager to elevate its customer retention game."
    }]
    cardsAboutUsContentHe = [
    {
      title: "המשימה שלנו לצמיחה שלך ",
      content: "Spin to Win שואפת לספק לכל בעל עסק את הכלים להגדיל הכנסות על ידי יצירת חוויית לקוח בלתי נשכחת. הפלטפורמה היא יותר מסתם מערכת - היא שותפה לצמיחה עסקית, ומציעה תמיכה במיתוג, שיווק ושימור לקוחות."
    },
    {
      title: "מה הופך את spinToWin לבחירה המושלמת שלך?",
      content: "• \nמספק חוויית לקוח מרגשת. \n מגדיל את ההכנסות ובנה נאמנות לקוחות. מתן תמיכה מלאה לעסקים לאורך כל תהליכי ההקמה והשיווק•\n"
    },
    {
      title: "תוצאות מוכחות ",
      content: "עם Spin to Win, עסקים ברחבי העולם עדים לשיפורים דרמטיים בשימור לקוחות ובצמיחה בהכנסות. עובדיה והצוות ממשיכים לחדש, לייעל ולתמוך בכל עסק שלהוט לשפר את משחק שימור הלקוחות שלו."
    },
  ]

  constructor(store: Store<AppState>) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadData(language);
    }));
  }

  ngOnInit(): void {
  }

  loadData(language: Language) {
  
    if(language==Language.en||language==Language.bg){
       this.cardsAboutUsContent=this.cardsAboutUsContentEn
    }
    else
    this.cardsAboutUsContent=this.cardsAboutUsContentHe
  }

  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }

}
